import React from 'react';
import { MapPin, Mail, Clock, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="relative py-32 bg-navy overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-burgundy/10 rounded-full -mr-48 -mt-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full -ml-48 -mb-48"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-light text-warm-white mb-6">
            Let's Build Something<br />
            <span className="font-medium">Exceptional</span>
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto"></div>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          <div className="bg-warm-white/5 backdrop-blur-sm p-8 rounded-xl border border-warm-white/10 hover:bg-warm-white/10 transition-all duration-300 text-center group">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-gold/20 text-gold rounded-full mb-4 group-hover:bg-gold group-hover:text-navy transition-all duration-300">
              <MapPin size={24} />
            </div>
            <h3 className="text-lg font-manrope font-semibold text-warm-white mb-3">
              Location
            </h3>
            <a
              href="https://www.google.com/maps/place/Kensetsu+Limited/@18.0119657,-76.7962534,17z/data=!4m14!1m7!3m6!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!2sKensetsu+Limited!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!3m5!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="text-warm-white/70 hover:text-gold transition-colors duration-300 text-sm font-manrope leading-relaxed"
            >
              1 Suthermere Road<br />
              Kingston, Jamaica
            </a>
          </div>

          <div className="bg-warm-white/5 backdrop-blur-sm p-8 rounded-xl border border-warm-white/10 hover:bg-warm-white/10 transition-all duration-300 text-center group">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-gold/20 text-gold rounded-full mb-4 group-hover:bg-gold group-hover:text-navy transition-all duration-300">
              <Mail size={24} />
            </div>
            <h3 className="text-lg font-manrope font-semibold text-warm-white mb-3">
              Email
            </h3>
            <a
              href="mailto:Kensetsulimited@gmail.com"
              className="text-warm-white/70 hover:text-gold transition-colors duration-300 text-sm font-manrope break-all"
            >
              Kensetsulimited@gmail.com
            </a>
          </div>

          <div className="bg-warm-white/5 backdrop-blur-sm p-8 rounded-xl border border-warm-white/10 hover:bg-warm-white/10 transition-all duration-300 text-center group">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-gold/20 text-gold rounded-full mb-4 group-hover:bg-gold group-hover:text-navy transition-all duration-300">
              <Phone size={24} />
            </div>
            <h3 className="text-lg font-manrope font-semibold text-warm-white mb-3">
              Phone
            </h3>
            <div className="space-y-2">
              <a
                href="tel:+18766715240"
                className="block text-warm-white/70 hover:text-gold transition-colors duration-300 text-sm font-manrope"
              >
                876-671-5240
                <span className="block text-xs text-warm-white/50 mt-1">Landline</span>
              </a>
              <a
                href="tel:+18763910515"
                className="block text-warm-white/70 hover:text-gold transition-colors duration-300 text-sm font-manrope"
              >
                876-391-0515
                <span className="block text-xs text-warm-white/50 mt-1">Mobile/WhatsApp</span>
              </a>
            </div>
          </div>

          <div className="bg-warm-white/5 backdrop-blur-sm p-8 rounded-xl border border-warm-white/10 hover:bg-warm-white/10 transition-all duration-300 text-center group">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-gold/20 text-gold rounded-full mb-4 group-hover:bg-gold group-hover:text-navy transition-all duration-300">
              <Clock size={24} />
            </div>
            <h3 className="text-lg font-manrope font-semibold text-warm-white mb-3">
              Hours
            </h3>
            <p className="text-warm-white/70 text-sm font-manrope leading-relaxed">
              Monday - Friday<br />
              8:30 AM - 4:30 PM
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-warm-white/5 backdrop-blur-sm p-12 rounded-2xl border border-warm-white/10">
            <h3 className="text-3xl font-playfair font-light text-warm-white mb-4">
              Ready to Start Your Project?
            </h3>
            <p className="text-warm-white/70 font-manrope mb-8 leading-relaxed-xl">
              Contact us today to discuss your custom furniture needs. Our team is ready to bring your vision to life with quality and attention to detail.
            </p>
            <a
              href="mailto:Kensetsulimited@gmail.com?subject=Request%20a%20Quote&body=Hello%20Kensetsu%20Limited,%0D%0A%0D%0AI%20would%20like%20to%20request%20a%20quote%20for%20custom%20furniture.%0D%0A%0D%0AThank%20you!"
              className="inline-block bg-gold text-navy px-8 py-4 rounded-lg text-base font-manrope font-semibold hover:bg-gold-light transition-all duration-300 shadow-lg hover:shadow-xl hover:translate-y-[-2px]"
            >
              Request a Quote
            </a>
          </div>
        </div>

        {/* Google Maps link */}
        <div className="mt-16 text-center">
          <a
            href="https://www.google.com/maps/place/Kensetsu+Limited/@18.0119657,-76.7962534,17z/data=!4m14!1m7!3m6!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!2sKensetsu+Limited!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!3m5!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="text-warm-white/50 hover:text-gold transition-colors duration-300 font-manrope text-sm underline"
          >
            View on Google Maps
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
